export var PHASE;
(function (PHASE) {
  PHASE[PHASE["PRIMARY"] = 1] = "PRIMARY";
  PHASE[PHASE["JUNIOR"] = 2] = "JUNIOR";
  PHASE[PHASE["SENIOR"] = 3] = "SENIOR";
})(PHASE || (PHASE = {}));
export var COURSE;
(function (COURSE) {
  COURSE[COURSE["CHINESE"] = 1] = "CHINESE";
  COURSE[COURSE["MATH"] = 2] = "MATH";
  COURSE[COURSE["ENGLISH"] = 3] = "ENGLISH";
  COURSE[COURSE["PHYSICS"] = 4] = "PHYSICS";
  COURSE[COURSE["CHEMISTRY"] = 5] = "CHEMISTRY";
  COURSE[COURSE["BIOLOGY"] = 6] = "BIOLOGY";
  COURSE[COURSE["POLITICS"] = 7] = "POLITICS";
  COURSE[COURSE["HISTORY"] = 8] = "HISTORY";
  COURSE[COURSE["GEOGRAPHY"] = 9] = "GEOGRAPHY";
  COURSE[COURSE["MORALITY_LAW"] = 10] = "MORALITY_LAW";
  COURSE[COURSE["SPORTS"] = 11] = "SPORTS";
  COURSE[COURSE["MUSIC"] = 12] = "MUSIC";
  COURSE[COURSE["FINA_ARTS"] = 13] = "FINA_ARTS";
  COURSE[COURSE["ART"] = 14] = "ART";
  COURSE[COURSE["SCIENCE"] = 15] = "SCIENCE";
  COURSE[COURSE["INREGRATIVE_PRACTICAL_ACTIVITIES"] = 16] = "INREGRATIVE_PRACTICAL_ACTIVITIES";
  COURSE[COURSE["TECHNOLOGY"] = 17] = "TECHNOLOGY";
})(COURSE || (COURSE = {}));